import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Link, animateScroll as scroll, scroller } from "react-scroll";
import Color from '../Colors/Color';
import Bars from "../SVGs/navbar-bars.svg"
import "./Navbar.css"
import { useStateContext } from '../../Contexts/productsCardContext';
import { useNavbarStateContext } from '../../Contexts/NavbarContect';
import {debounce} from 'lodash'
import Announcement from '../../Models/Announcement';

const Navbar1 = () => {
    // const {page} = useStateContext();

    // useEffect(() => {
    //     console.log(page)
    // }, [page])
      
    const navigate = useNavigate();

    const {drawerOpen, setDrawerOpen} = useNavbarStateContext();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    
    const closeMobileMenu = () =>  setClick(false);

    const changePage = (pages) => {
        
        switch(pages){
            case "home": {
                navigate("/");
                break;
            }
            case "products": {
                navigate("/products");
                break;
            }
            case "services": {
                navigate("/services");
                break;
            }
            default:{
                navigate("/");
                break;
            }
        }

        closeMobileMenu();
    }

    useEffect(() => {
        if(click === true){
            setDrawerOpen(true);
            document.body.classList.add('remove-scroll');
        } else{
            setDrawerOpen(false);
            document.body.classList.remove('remove-scroll');
        }
    },[click])

    useEffect(() =>{
        const handleExpandChange = debounce(() =>{
            setWindowWidth(window.innerWidth);
            if(window.innerWidth > 768){
                setDrawerOpen(false);
                setClick(false);
                document.body.classList.remove('remove-scroll');
            }
        },300)
            window.addEventListener("resize", handleExpandChange);
            
            return () => {
            window.removeEventListener("resize", handleExpandChange);
            };
       
    }, [setDrawerOpen]);

    useEffect(() => {
        if (drawerOpen) {
            scroller.scrollTo('navbar-container', {
                duration: 0,
                delay: 0,
                smooth: 'easeInOutQuart'
            });
        }
    }, [drawerOpen]);


  return (
    <>
        <Announcement />

        <nav className='navbar-container' style={{backgroundColor: Color.primaryBackground}} id='navbar'>
            <div className='navbar-logo-container'>
                <img src='/Images/logo.png' alt='opc-logo' className='navbar-logo' onClick={() => changePage('home')}/>
            </div>

            <div className='navbar-bar-container' onClick={handleClick}>
                <svg fill="#ffffff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" strokeWidth="0.64" className="navbar-bar">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> 
                    <title>bars-sort</title> <path d="M30 6.749h-28c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h28c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM18 14.75h-16c-0.69 
                    0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h16c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM8.053 22.75h-6.053c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h6.053c0.69 
                    0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0z"></path> 
                    </g>
                </svg>     
            </div>

            <div className={`navbar-menu-container${click ? "" : "" }`}>
                    <ul className="navbar-menu-list">
                        <li className="navbar-item">
                            <Link
                                activeClass="navbar-link active"
                                className="navbar-link"
                                to="home"
                                spy={true}
                                smooth={true}
                                offset={-120}
                                duration={150}
                                onClick={() => changePage('home')}
                                style={{color: Color.secondaryText}}
                            >
                                Home
                            </Link>
                        </li>

                        <li className="navbar-item">
                            <Link
                                activeClass="navbar-link active"
                                className="navbar-link"
                                to="service"
                                spy={true}
                                smooth={true}
                                offset={-94}
                                duration={150}
                                onClick={() => changePage('services')}
                                style={{color: Color.secondaryText}}
                            >
                                Services
                            </Link>
                        </li>

                        
                        <li className="navbar-item">
                            <Link
                                activeClass="navbar-link active"
                                className="navbar-link"
                                // spy={true}
                                // smooth={true}
                                // offset={-94}
                                // duration={150}
                                onClick={() => changePage('products')}
                                style={{color: Color.secondaryText}}
                            >
                                Products
                            </Link>
                        </li>

                        <li className="navbar-item">
                            <Link
                                activeClass="navbar-link active"
                                className="navbar-link"
                                // to={page == 'other' ? 'footer' : 'contact-us'}
                                to="footer"
                                spy={true}
                                smooth={true}
                                offset={-50}
                                duration={150}
                                onClick={closeMobileMenu}
                                style={{color: Color.secondaryText}}
                            >
                                Contact Us
                            </Link>
                        </li>

                    </ul>
                </div>
        </nav>

        <div className={`navbar-drawer${click ? "-active" : ""}`} onClick={closeMobileMenu}>

            <div style={{backgroundColor: Color.primaryBackground}} className= {`navbar-drawer-container${click ? "-active" : ""}`} onClick={(e) => e.stopPropagation()}>

                <div className='navbar-drawer-logo-container'>
                    <img src='/Images/logo.png' alt='opc-logo' className='navbar-logo navbar-drawer-logo' onClick={() => changePage('home')}/>
                </div>

                <ul className="navbar-drawer-list">
                    <li className="navbar-drawer-item">
                        <Link
                            activeClass="navbar-drawer-link active"
                            className="navbar-drawer-link"
                            to="home"
                            spy={true}
                            smooth={true}
                            offset={-120}
                            duration={150}
                            onClick={() => changePage('home')}
                            style={{color: Color.secondaryText}}
                        >
                            Home
                        </Link>
                    </li>

                    <li className="navbar-drawer-item">
                        <Link
                            activeClass="navbar-drawer-link active"
                            className="navbar-drawer-link"
                            to="service"
                            spy={true}
                            smooth={true}
                            offset={-94}
                            duration={150}
                            onClick={() => changePage('services')}
                            style={{color: Color.secondaryText}}
                        >
                            Services
                        </Link>
                    </li>

                    
                    <li className="navbar-drawer-item">
                        <Link
                            activeClass="navbar-drawer-link active"
                            className="navbar-drawer-link"
                            // spy={true}
                            // smooth={true}
                            // offset={-94}
                            // duration={150}
                            onClick={() => changePage('products')}
                            style={{color: Color.secondaryText}}
                        >
                            Products
                        </Link>
                    </li>

                    <li className="navbar-drawer-item">
                        <Link
                            activeClass="navbar-drawer-link active"
                            className="navbar-drawer-link"
                            to="footer"
                            spy={true}
                            smooth={true}
                            offset={-50}
                            duration={150}
                            onClick={closeMobileMenu}
                            style={{color: Color.secondaryText}}
                        >
                            Contact Us
                        </Link>
                    </li>

                </ul>
            </div>
            
        </div>
    </>
  )
}

export default Navbar1